"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationLogo = exports.OrganisationLogoDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_element_1 = require("../elements/image-element");
var coalesce_1 = require("../../utils/coalesce");
exports.OrganisationLogoDefaultProps = {
  maxHeight: '140px'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FauxLogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: #FFF;\n    text-decoration: none;\n    background: ", ";\n    text-transform: capitalize;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", ";\n    margin: ", " 0;\n    font-weight: 500;\n    text-align: center;\n  "], ["\n    color: #FFF;\n    text-decoration: none;\n    background: ", ";\n    text-transform: capitalize;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", ";\n    margin: ", " 0;\n    font-weight: 500;\n    text-align: center;\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.UNIT(3))
});
var LogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    margin-right: 2px;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n  "], ["\n    display: flex;\n    margin-right: 2px;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), function (props) {
    return props.minHeight && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      min-height: ", ";\n    "], ["\n      min-height: ", ";\n    "])), props.minHeight);
  })
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 100%;\n\n    ", "\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  "], ["\n    max-width: 100%;\n\n    ", "\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  "])), function (props) {
    return props.maxHeight && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      max-height: ", ";\n    "], ["\n      max-height: ", ";\n    "])), props.maxHeight);
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Logo: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  FauxLogo: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FauxLogoStyles),
  Image: (0, styled_components_1.default)(image_element_1.ImageElement)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
var OrganisationLogo = function (props) {
  var className = props.className,
    entity = props.entity,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    minHeight = props.minHeight;
  var logo = (0, coalesce_1.coalesce)(entity, ['logo', 'openGraph.image']);
  return react_1.default.createElement(My.Container, {
    className: className
  }, logo ? react_1.default.createElement(My.Logo, {
    minHeight: minHeight
  }, react_1.default.createElement(My.Image, {
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    entity: logo
  })) : react_1.default.createElement(My.FauxLogo, null, entity.name));
};
exports.OrganisationLogo = OrganisationLogo;
exports.OrganisationLogo.defaultProps = exports.OrganisationLogoDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;